
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/peachjohn",
      function () {
        return require("private-next-pages/cases/peachjohn/index.tsx");
      }
    ]);
  